<template>
  <v-col class="mx-4">
    <div>
      <h1 class="text-center">
        You don't have permission to access to resource
      </h1>
    </div>
  </v-col>
</template>

<script>
export default {};
</script>
<style>
.error-page {
  text-align: center;
  margin-top: 50px;
}
</style>
